import React, { useState } from 'react';
import './Contact.css';

const services = [
  'Electronic Product Design',
  'PCB Fabrication',
  'PCB Assembly (PCBA)',
  'EMS / Turnkey Manufacturing',
  'Box Build Assembly',
  'Component Sourcing',
  'Testing & Validation',
  'Other',
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', company: '', phone: '', service: '', volume: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [focused, setFocused] = useState('');

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <main className="contact-page page-wrapper">
      <section className="page-hero">
        <div className="page-hero__bg" />
        <div className="container page-hero__inner">
          <div className="section-tag" style={{ background: 'rgba(0,194,224,0.15)', color: 'var(--cyan)' }}>Contact Us</div>
          <h1 className="page-hero__title">Let's Build Something <span>Together</span></h1>
          <p className="page-hero__subtitle">
            Tell us about your project — a BOM, a brief, or just an idea. We'll get back to you within 24 hours.
          </p>
        </div>
      </section>

      <section className="section contact-section">
        <div className="container contact-grid">
          {/* Form */}
          <div className="contact-form-wrapper">
            {submitted ? (
              <div className="form-success">
                <div className="success-icon">✓</div>
                <h3>Message Received!</h3>
                <p>Thanks for reaching out. Our team will respond within 24 hours with next steps.</p>
                <button className="btn-primary" style={{ marginTop: 24 }} onClick={() => setSubmitted(false)}>
                  Send Another Message
                </button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit} noValidate>
                <div className="form-header">
                  <h2>Get a Free Quote</h2>
                  <p>Fill in the details below and our engineering team will prepare a tailored response.</p>
                </div>

                <div className="form-row">
                  <div className={`form-group${focused === 'name' || form.name ? ' form-group--active' : ''}`}>
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      onFocus={() => setFocused('name')}
                      onBlur={() => setFocused('')}
                      required
                      placeholder="Prerana k"
                    />
                  </div>
                  <div className={`form-group${focused === 'email' || form.email ? ' form-group--active' : ''}`}>
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      onFocus={() => setFocused('email')}
                      onBlur={() => setFocused('')}
                      required
                      placeholder="@company.com"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className={`form-group${focused === 'company' || form.company ? ' form-group--active' : ''}`}>
                    <label htmlFor="company">Company Name</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={form.company}
                      onChange={handleChange}
                      onFocus={() => setFocused('company')}
                      onBlur={() => setFocused('')}
                      placeholder="Your Company Ltd."
                    />
                  </div>
                  <div className={`form-group${focused === 'phone' || form.phone ? ' form-group--active' : ''}`}>
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      onFocus={() => setFocused('phone')}
                      onBlur={() => setFocused('')}
                      placeholder="+91 821 4244515"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className={`form-group${focused === 'service' || form.service ? ' form-group--active' : ''}`}>
                    <label htmlFor="service">Service Required *</label>
                    <select
                      id="service"
                      name="service"
                      value={form.service}
                      onChange={handleChange}
                      onFocus={() => setFocused('service')}
                      onBlur={() => setFocused('')}
                      required
                    >
                      <option value="">Select a service</option>
                      {services.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </div>
                  <div className={`form-group${focused === 'volume' || form.volume ? ' form-group--active' : ''}`}>
                    <label htmlFor="volume">Expected Volume</label>
                    <select
                      id="volume"
                      name="volume"
                      value={form.volume}
                      onChange={handleChange}
                      onFocus={() => setFocused('volume')}
                      onBlur={() => setFocused('')}
                    >
                      <option value="">Select volume</option>
                      <option>100–500 units</option>
                      <option>500–5,000 units</option>
                      <option>5,000–50,000 units</option>
                      <option>50,000–500,000 units</option>
                      <option>500,000+ units</option>
                    </select>
                  </div>
                </div>

                <div className={`form-group form-group--full${focused === 'message' || form.message ? ' form-group--active' : ''}`}>
                  <label htmlFor="message">Project Brief *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    onFocus={() => setFocused('message')}
                    onBlur={() => setFocused('')}
                    required
                    rows={5}
                    placeholder="Describe your project — product type, current stage, key requirements, timeline, or any files you'd like to share..."
                  />
                </div>

                <button type="submit" className="btn-primary form-submit">
                  Send Message & Request Quote
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </button>

                <p className="form-note">We respond to all enquiries within 24 business hours.</p>
              </form>
            )}
          </div>

          {/* Info */}
          <div className="contact-info">
            <div className="contact-info-card">
              <h3>Get in Touch</h3>
              <div className="contact-item">
                <div className="contact-item-icon">📍</div>
                <div>
                  <strong>Office & Factory</strong>
                  <span>No. 123-127, 1st Floor<br />Metagalli Industrial Area, Mysore - 570016, Karnataka, India</span>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-item-icon">✉️</div>
                <div>
                  <strong>Email Us</strong>
                  <a href="mailto:info@zxeonfs.com" className="inline-link">info@zxeonfs.com</a>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-item-icon">📞</div>
                <div>
                  <strong>Call Us</strong>
                  <span>+91 821 4244515</span>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-item-icon">🕐</div>
                <div>
                  <strong>Business Hours</strong>
                  <span>Mon–Sat, 9:00 AM – 6:00 PM IST</span>
                </div>
              </div>
            </div>

            <div className="contact-info-card">
              <h3>Quick Facts</h3>
              {[
                { icon: '⚡', text: '24hr response to all enquiries' },
                { icon: '🔒', text: 'NDA available on request' },
                { icon: '📁', text: 'Accepts Gerber, BOM, PDF briefs' },
                { icon: '🚀', text: '48hr prototype turnaround available' },
                { icon: '🌍', text: 'Worldwide delivery & logistics' },
              ].map(f => (
                <div key={f.text} className="quick-fact">
                  <span>{f.icon}</span>
                  <span>{f.text}</span>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/* Full-width Map Section */}
      <section className="section contact-map-section">
        <div className="container">
          <div className="contact-map-full">
            <div className="contact-map-full__header">
              <h3>Our Location</h3>
              <a
                href="https://www.google.com/maps/place/Saalfo+Tech+Pvt+Ltd/@12.3558876,76.6354054,17z"
                target="_blank"
                rel="noopener noreferrer"
                className="map-directions-link"
              >
                📍 Get Directions →
              </a>
            </div>
            <iframe
              title="Saalfo Tech Pvt Ltd Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d982.3583004!2d76.6373832!3d12.3583004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baf7a0e91357d7b%3A0x63547d28ef8bd467!2sSaalfo%20Tech%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0, borderRadius: '12px', display: 'block' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>
    </main>
  );
}